import { Maybe } from '@aibees/shared/definition';
import { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const accordionAction: SxStyleFunc<Maybe<number>> = (size?: number) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: (p) => p.palette.grey[200],
  height: `${size ?? 18}px`, // Match the Icon size
  borderRadius: (p) => p.spacing(0.5),
});

export const iconContainer: SxStyle = {
  height: '18px', // Match the Icon size
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const iconHover: SxStyleFunc<boolean | undefined> = (disabled) => ({
  ...(!disabled && {
    ':hover': {
      color: (p) => p.palette.primary.main,
    },
  }),
});
